import { computed, reactive } from 'vue';
import { useStore } from 'dashboard/composables/store';
import CrmAPI from 'dashboard/api/crm';

const states = reactive({});
export function useCrm(conversationId) {
  const store = useStore();
  const key = computed(
    () => `${store.getters.getCurrentAccountId}:${conversationId.value}`
  );
  const state = computed(() => {
    if (!states[key.value])
      states[key.value] = {
        data: null,
        busy: false,
        error: '',
        closing: false,
      };
    return states[key.value];
  });
  const load = async (before = null) => {
    if (!conversationId.value) return;
    const target = state.value;
    target.busy = true;
    target.error = '';
    try {
      const response = (
        await CrmAPI.conversation(
          conversationId.value,
          before ? { event_before: before } : undefined
        )
      ).data;
      if (before && target.data) {
        target.data.events.push(...response.events);
        target.data.more_events = response.more_events;
      } else {
        target.data = response;
      }
    } catch (e) {
      target.error = e.response?.data?.error || e.message;
    } finally {
      target.busy = false;
    }
  };
  const act = async (operation, record, extra = {}) => {
    const target = state.value;
    target.busy = true;
    target.error = '';
    try {
      target.data = (
        await CrmAPI.act(conversationId.value, {
          operation,
          funnel_id: record.funnel_id,
          version: record.version,
          ...extra,
        })
      ).data;
      return true;
    } catch (e) {
      if (e.response?.status === 409) await load();
      target.error = e.response?.data?.error || e.message;
      return false;
    } finally {
      target.busy = false;
    }
  };
  const active = computed(() =>
    state.value.data?.records.find(r => r.state.status === 'active')
  );
  const loadOlder = () => load(state.value.data?.events.at(-1)?.id);
  return { state, active, load: () => load(), loadOlder, act };
}
